<div class="session-timeout-wrapper">

  <div mat-dialog-title>
    <label class="popupTitle" for="label">Session Timeout</label>
  </div>

  <div class="session-timeout-body">
    <div class="timeout-text">
      <p class="timeout-line">
        Your session is about to expire in
        <span class="seconds">{{ idleState }}</span>
        seconds due to idle time.
      </p>

      <p>
        Click <span class="bold">OK</span> to continue this session.
      </p>
    </div>
  </div>

  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="stay()">
      OK
    </button>
  </div>

</div>
